import { type FC, type KeyboardEventHandler } from 'react';
import type { MenuItem } from '../../../../../../../../components/blackrock/advisor-center/_types/navigation.ts';

type Props = {
	menuItem?: MenuItem;
	isMyProfileOpened: boolean;
	onKeyDownItem: KeyboardEventHandler<HTMLAnchorElement> | undefined;
	focusableElements: HTMLElement[];
};

const MyProfileAnchor: FC<Props> = ({
	menuItem,
	isMyProfileOpened,
	onKeyDownItem,
	focusableElements,
}) => {
	if (!menuItem) {
		return null;
	}

	return (
		<a
			data-final-url
			href={menuItem.href}
			onKeyDown={onKeyDownItem}
			ref={(ref) => ref && focusableElements.push(ref)}
			tabIndex={isMyProfileOpened ? 0 : -1}
			aria-label={menuItem.ariaLabel}
			target={menuItem.target ?? undefined}
			rel={menuItem.rel ?? undefined}
			data-link-event={menuItem.dataLinkEvent}
			className="blk-ac-body-s"
		>
			{menuItem.displayValue}
		</a>
	);
};

export default MyProfileAnchor;
